<template>
    <div>
        <PageHeader :page="page" :template="'2'" @action="createNew" v-if="!state.loading"/>
        <div class="content" v-if="!state.loading">
            <DataTable :tableData="tableData" @edit="edit"/>
        </div>
        <div v-if="state.loading" style="text-align: center;">
          <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </div>

    <ModalView
        :isVisible="state.CreateModal"
        :fixclose="true"
        @close="state.CreateModal = false">
        
        <DynamicForm ref="createForm" :columns="2"
        :fields="newFields" @submit="createAccount"
        :submitting="state.submitting" :errors="state.errors"
        :success="state.success" />
    </ModalView> 

    <ModalView
        :isVisible="state.editModal"
        :fixclose="true"
        @close="state.editModal = false">
        
        <DynamicForm :columns="2"
        :fields="editFields" @submit="editAccount"
        :submitting="state.submitting" :errors="state.errors"
        :success="state.success" />
    </ModalView>
</template>
<script>
import icons from '@/assets/js/icons.js';
import { reactive, ref, onMounted, computed} from 'vue';
import { useStore } from 'vuex';
import PageHeader from '@/components/PageHeader.vue';
import DataTable from '@/components/DataTable.vue';
import { usePermissions } from '@/composables/usePermissions';
import DynamicForm from '@/components/DynamicForm.vue';
import ModalView from '@/components/ModalView.vue';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
export default {
    name: 'TransactionsView',
    components:{PageHeader, DataTable,DynamicForm,ModalView},
    setup(){
        const store= useStore();
        const system = computed(() => store.state.System.system);
        const { hasPermission } = usePermissions();
        const editFields=ref([]);
        const createForm=ref(null);
        const account_type=ref([]);
        const state=reactive({CreateModal:false, submitting:false,error:[],success:false,
        loading:true,editTaskModal:false,gettingTask:false,historyModal:false,historyLoading:true
        });
        const svgIcons = ref(icons);
        const page=ref({title:"Chart of Account", btn:"Add Account",
            desc:"Manage all Accounts in one place"})
        if(!hasPermission('Accounts', 'create')){
            page.value.btn="";
        }
        var action_label=[];
        var action=[];
        if(hasPermission('Accounts', 'edit')){
        action_label.push(icons.edit);
        action.push("edit")
        }

        const newFields=ref([
            { name: "Create Account", number: "1",data: 
                [{ type: 'text', name: 'name', label: 'Account Name',
                value: ""  },
                { type: 'select', name: 'type', label: 'Account Type',
                value: "", options:account_type  },
                { type: 'text', name: 'desc', label: 'Description',
                value: ""  },
                ]
            }
        ])

        function setTable(msg){
            var data={}
            tableData.value.loading = false;
            tableData.value.rows.length=0
            Object.keys(msg).forEach(set => {
                data={id:msg[set].id};
                var v=[];
                Object.keys(msg[set].val).forEach(row => {
                v.push(msg[set].val[row])
                });
                data.val=v;
                tableData.value.rows.push(data)
            });
            tableData.value.total=tableData.value.rows.length
        }

        const tableData = ref({
            rows: [],
            loading: true,
            columns: [
                { label: "Name" },
                { label: "Account Type" },
                { label: "Description" }
            ],
            options:{
                label:"Actions",
                action_label:action_label,
                action:action,
            },
            total:0
        });

        onMounted(() => { 
            call({
                url:urls.transactions,
                data:{startAccount:""},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        var d=res.msg;
                        account_type.value=[];
                        Object.keys(d.type).forEach(k => {
                            account_type.value.push(d.type[k])
                        })
                        setTable(d.accounts);
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        function createNew(){
            if(system.value.acct_type=="full"){
                state.success=false;
                state.error=[]
                state.CreateModal=true;
            }else if(system.value.acct_type=="simple"){
                alert("This office uses a simple accounting system that doesn't support this feature. For more information, please contact your system administrator.")
            }else{
                alert("Office accounting settings not found. Please contact your system administrator to configure accounting settings to continue")
            }
        }

        function setErrors(res){
            var errors=[];
            Object.keys(res.msg).forEach(key => {
            var e=res.msg[key],er="";
            Object.keys(e).forEach(k => {
                er+=er=="" ? e[k] : ", "+e[k]
            })
            errors.push(er);
            });
            state.errors=errors;
        }

        function createAccount(data){
            state.submitting=true;
            state.errors=[];
            data.createAccount="";
            call({
                url:urls.transactions,
                data:data,
                success:(res)=>{
                    state.submitting=false;
                    if(res.status){
                        state.success=true;
                        setTable(res.msg);
                    }else{
                        setErrors(res)
                    }
                }
            })
        }

        function edit(i){
            state.success=false;
            state.error=[]
            var data=tableData.value.rows[i]
            editFields.value.length=0;
            editFields.value.push(
                { name: "Edit Account", number: "1",data: 
                    [{ type: 'text', name: 'name', label: 'Account Name',
                    value: data.val[0]  },
                    { type: 'select', name: 'type', label: 'Account Type',
                    value: data.val[1].toLowerCase(), options:account_type  },
                    { type: 'text', name: 'desc', label: 'Description',
                    value: data.val[2]  },
                    { type: 'hidden', name: 'id',
                    value: data.id  }
                    ]
                }
            )
            state.editModal=true;
        }

        function editAccount(data){
            state.submitting=true;
            state.errors=[];
            data.createAccount="";
            call({
                url:urls.transactions,
                data:data,
                success:(res)=>{
                state.submitting=false;
                if(res.status){
                    state.success=true;
                    setTable(res.msg);
                }else{
                    setErrors(res)
                }
                }
            })
        }
        
        

        return{createForm,state, icons:svgIcons,tableData,newFields,page,edit,
            createNew,createAccount,editFields,editAccount}
    }
}
</script>